// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SeparatorLine-module__font-s-10___zvtAV {
  font-size: 10px !important;
}

.SeparatorLine-module__font-s-12___W83Kb {
  font-size: 12px !important;
}

.SeparatorLine-module__font-s-13___on1S7 {
  font-size: 13px !important;
}

.SeparatorLine-module__font-s-14___KxQpm {
  font-size: 14px !important;
}

.SeparatorLine-module__font-s-15___MeZ74 {
  font-size: 15px !important;
}

.SeparatorLine-module__font-s-16___wEc5m {
  font-size: 16px !important;
}

.SeparatorLine-module__font-s-18___mUsFd {
  font-size: 18px !important;
}

.SeparatorLine-module__font-s-20___gTXSI {
  font-size: 20px !important;
}

.SeparatorLine-module__font-s-22___B7g6m {
  font-size: 22px !important;
}

.SeparatorLine-module__font-s-28___k3cns {
  font-size: 28px !important;
}

.SeparatorLine-module__font-w-400___EmaIc {
  font-weight: 400 !important;
}

.SeparatorLine-module__font-w-500___CXHf9 {
  font-weight: 500 !important;
}

.SeparatorLine-module__font-w-600___NpxCT {
  font-weight: 600 !important;
}

.SeparatorLine-module__font-w-700___kHOT3 {
  font-weight: 700 !important;
}

.SeparatorLine-module__p-5___OGZir {
  padding: 5px !important;
}

.SeparatorLine-module__p-12___UDmba {
  padding: 12px !important;
}

.SeparatorLine-module__p-16___sonIr {
  padding: 16px !important;
}

.SeparatorLine-module__p-30___JcIwr {
  padding: 30px !important;
}

.SeparatorLine-module__p-b-0___BpzSk {
  padding-bottom: 0 !important;
}

.SeparatorLine-module__p-b-5___xP9YU {
  padding-bottom: 5px !important;
}

.SeparatorLine-module__p-b-10___C05WU {
  padding-bottom: 10px !important;
}

.SeparatorLine-module__p-b-12___MEV7e {
  padding-bottom: 12px !important;
}

.SeparatorLine-module__p-b-16___Qh_CK {
  padding-bottom: 16px !important;
}

.SeparatorLine-module__p-b-18___oPOMz {
  padding-bottom: 18px !important;
}

.SeparatorLine-module__p-b-20___D9S8k {
  padding-bottom: 20px !important;
}

.SeparatorLine-module__p-b-25___NK22f {
  padding-bottom: 25px !important;
}

.SeparatorLine-module__p-b-30___aPxag {
  padding-bottom: 30px !important;
}

.SeparatorLine-module__p-b-50___aOoRo {
  padding-bottom: 50px !important;
}

.SeparatorLine-module__p-t-0___tFBVS {
  padding-top: 0 !important;
}

.SeparatorLine-module__p-t-12___pcOO7 {
  padding-top: 12px !important;
}

.SeparatorLine-module__p-t-16___inVw1 {
  padding-top: 16px !important;
}

.SeparatorLine-module__p-t-18___pApgL {
  padding-top: 18px !important;
}

.SeparatorLine-module__p-t-20___d1hV0 {
  padding-top: 20px !important;
}

.SeparatorLine-module__p-t-30___xqr2F {
  padding-top: 30px !important;
}

.SeparatorLine-module__p-t-40___hpq7u {
  padding-top: 40px !important;
}

.SeparatorLine-module__p-t-50___weqDy {
  padding-top: 50px !important;
}

.SeparatorLine-module__p-l-20___HXE7g {
  padding-left: 20px !important;
}

.SeparatorLine-module__p-l-30___I09fJ {
  padding-left: 30px !important;
}

.SeparatorLine-module__p-l-40___zlwAd {
  padding-left: 40px !important;
}

.SeparatorLine-module__p-r-16___scSxZ {
  padding-right: 16px !important;
}

.SeparatorLine-module__p-r-20___lq_zE {
  padding-right: 20px !important;
}

.SeparatorLine-module__p-r-30___mDQOs {
  padding-right: 30px !important;
}

.SeparatorLine-module__p-r-50___CVxin {
  padding-right: 50px !important;
}

.SeparatorLine-module__p-r-60___nyJ68 {
  padding-right: 60px !important;
}

.SeparatorLine-module__m-b-1___ZTu2U {
  margin-bottom: 1px !important;
}

.SeparatorLine-module__m-b-2___jYoDn {
  margin-bottom: 2px !important;
}

.SeparatorLine-module__m-b-6___hEnMa {
  margin-bottom: 6px !important;
}

.SeparatorLine-module__m-b-8___qi58O {
  margin-bottom: 8px !important;
}

.SeparatorLine-module__m-b-10___ggCSM {
  margin-bottom: 10px !important;
}

.SeparatorLine-module__m-b-14___RGv1S {
  margin-bottom: 14px !important;
}

.SeparatorLine-module__m-b-16___Xbj59 {
  margin-bottom: 16px !important;
}

.SeparatorLine-module__m-b-20___IkXlY {
  margin-bottom: 20px !important;
}

.SeparatorLine-module__m-b-22___NuUza {
  margin-bottom: 22px !important;
}

.SeparatorLine-module__m-b-24___jVNnD {
  margin-bottom: 24px !important;
}

.SeparatorLine-module__m-b-30___nay8i {
  margin-bottom: 30px !important;
}

.SeparatorLine-module__m-b-32___ii4c8 {
  margin-bottom: 32px !important;
}

.SeparatorLine-module__m-b-40___YEpIE {
  margin-bottom: 40px !important;
}

.SeparatorLine-module__m-t-2___k6V9n {
  margin-top: 2px !important;
}

.SeparatorLine-module__m-t-3___Xz0pi {
  margin-top: 3px !important;
}

.SeparatorLine-module__m-t-4___IrIUq {
  margin-top: 4px !important;
}

.SeparatorLine-module__m-t-5___HtCqC {
  margin-top: 5px !important;
}

.SeparatorLine-module__m-t-8___g8Q_7 {
  margin-top: 8px !important;
}

.SeparatorLine-module__m-t-10___qxE0x {
  margin-top: 10px !important;
}

.SeparatorLine-module__m-t-15____MtkX {
  margin-top: 15px !important;
}

.SeparatorLine-module__m-t-16___N26KF {
  margin-top: 16px !important;
}

.SeparatorLine-module__m-t-20___qEthe {
  margin-top: 20px !important;
}

.SeparatorLine-module__m-t-22___FFxtz {
  margin-top: 22px !important;
}

.SeparatorLine-module__m-t-30___Yftwf {
  margin-top: 30px !important;
}

.SeparatorLine-module__m-t-32___ZZ2Tj {
  margin-top: 32px !important;
}

.SeparatorLine-module__m-l-auto___JJPNX {
  margin-left: auto !important;
}

.SeparatorLine-module__m-l-4___FNN6U {
  margin-left: 4px !important;
}

.SeparatorLine-module__m-l-5___X311K {
  margin-left: 5px !important;
}

.SeparatorLine-module__m-l-6___TuWr4 {
  margin-left: 6px !important;
}

.SeparatorLine-module__m-l-8___XG0F8 {
  margin-left: 8px !important;
}

.SeparatorLine-module__m-l-10___BPm70 {
  margin-left: 10px !important;
}

.SeparatorLine-module__m-l-16___Ayk9j {
  margin-left: 16px !important;
}

.SeparatorLine-module__m-l-20___fJLaX {
  margin-left: 20px !important;
}

.SeparatorLine-module__m-l-24___uPrRl {
  margin-left: 24px !important;
}

.SeparatorLine-module__m-l-30___PyEjN {
  margin-left: 30px !important;
}

.SeparatorLine-module__m-l-35___t6Fkz {
  margin-left: 35px !important;
}

.SeparatorLine-module__m-l-40___bBd7Z {
  margin-left: 40px !important;
}

.SeparatorLine-module__m-r-8___QJC9j {
  margin-right: 8px !important;
}

.SeparatorLine-module__m-r-10___zBG5t {
  margin-right: 10px !important;
}

.SeparatorLine-module__m-r-16___QQyF6 {
  margin-right: 16px !important;
}

.SeparatorLine-module__m-r-20___gisEb {
  margin-right: 20px !important;
}

.SeparatorLine-module__m-r-24___QStck {
  margin-right: 24px !important;
}

.SeparatorLine-module__m-r-30___nYkIN {
  margin-right: 30px !important;
}

.SeparatorLine-module__m-r-40___rGWGT {
  margin-right: 40px !important;
}

.SeparatorLine-module__border-r-3___nC60m {
  border-radius: 3px !important;
}

.SeparatorLine-module__border-r-4___LfCK8 {
  border-radius: 4px !important;
}

.SeparatorLine-module__border-r-6___rPHcI {
  border-radius: 6px !important;
}

.SeparatorLine-module__border-r-10___MWWxJ {
  border-radius: 10px !important;
}

.SeparatorLine-module__border-r-12___NynAS {
  border-radius: 12px !important;
}

.SeparatorLine-module__border-r-16___z4pR2 {
  border-radius: 16px !important;
}

.SeparatorLine-module__border-r-50___DntHm {
  border-radius: 50% !important;
}

.SeparatorLine-module__primary-border___KonWx {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SeparatorLine-module__primary-border-b___jEzEj {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SeparatorLine-module__primary-border-t___Y1BFx {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SeparatorLine-module__primary-border-l___Jl_Hy {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SeparatorLine-module__primary-border-r___kk2_j {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SeparatorLine-module__secondary-border___jw8rl {
  border: 1px solid #637768;
}

.SeparatorLine-module__secondary-border-b___R7WGS {
  border-bottom: 1px solid #637768;
}

.SeparatorLine-module__secondary-border-t___yLN9P {
  border-top: 1px solid #637768;
}

.SeparatorLine-module__secondary-border-l___XcLOy {
  border-left: 1px solid #637768;
}

.SeparatorLine-module__secondary-border-r___TEyiT {
  border-right: 1px solid #637768;
}

.SeparatorLine-module__gap-0___Myj8k {
  gap: 0 !important;
}

.SeparatorLine-module__gap-2___Xc4Bh {
  gap: 2px !important;
}

.SeparatorLine-module__gap-4___TLGDE {
  gap: 4px !important;
}

.SeparatorLine-module__gap-5___yTnD7 {
  gap: 5px !important;
}

.SeparatorLine-module__gap-6___ZObg_ {
  gap: 6px !important;
}

.SeparatorLine-module__gap-8___ZuOlR {
  gap: 8px !important;
}

.SeparatorLine-module__gap-10___HeDGj {
  gap: 10px !important;
}

.SeparatorLine-module__gap-12___Ia44U {
  gap: 12px !important;
}

.SeparatorLine-module__gap-14___lwttQ {
  gap: 14px !important;
}

.SeparatorLine-module__gap-16____BqrX {
  gap: 16px !important;
}

.SeparatorLine-module__gap-18___C2RnX {
  gap: 18px !important;
}

.SeparatorLine-module__gap-20___iifhu {
  gap: 20px !important;
}

.SeparatorLine-module__gap-24___vg2xG {
  gap: 24px !important;
}

.SeparatorLine-module__gap-26___qQGlt {
  gap: 26px !important;
}

.SeparatorLine-module__gap-30___Ui2Hc {
  gap: 30px !important;
}

.SeparatorLine-module__gap-32___unGeY {
  gap: 32px !important;
}

.SeparatorLine-module__gap-40___wDTg3 {
  gap: 40px !important;
}

.SeparatorLine-module__gap-50___bibKz {
  gap: 50px !important;
}

.SeparatorLine-module__flex-1___aQLKw {
  flex: 1;
}

.SeparatorLine-module__flex-none___b7By0 {
  flex: none !important;
}

.SeparatorLine-module__flex-column___wRcYO {
  display: flex;
  flex-direction: column !important;
}

.SeparatorLine-module__flex-row___BW0ef {
  display: flex;
  flex-direction: row !important;
}

.SeparatorLine-module__vertically-centered___byXDG {
  display: flex;
  align-items: center !important;
}

.SeparatorLine-module__horizontally-centered___bpZ5p {
  display: flex;
  justify-content: center !important;
}

.SeparatorLine-module__horizontally-end___MczDj {
  display: flex;
  justify-content: end !important;
}

.SeparatorLine-module__vertically-start___eKCHu {
  display: flex;
  align-items: start !important;
}

.SeparatorLine-module__space-between___zdMuN {
  display: flex;
  justify-content: space-between !important;
}

.SeparatorLine-module__flex-wrap____nteG {
  flex-wrap: wrap !important;
}

.SeparatorLine-module__height-100___lUcK1 {
  height: 100%;
}

.SeparatorLine-module__width-50___W70BG {
  width: 50% !important;
}

.SeparatorLine-module__width-100___Oc0jD {
  width: 100%;
}

.SeparatorLine-module__cursor-pointer___n40FR {
  cursor: pointer;
}

.SeparatorLine-module__cursor-not-allowed___HIU_m {
  cursor: not-allowed !important;
}

.SeparatorLine-module__absolute-centered___poS94 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SeparatorLine-module__absolute___Cfknh {
  position: absolute;
}

.SeparatorLine-module__relative___YoqEh {
  position: relative;
}

.SeparatorLine-module__fixed___piBmG {
  position: fixed;
}

.SeparatorLine-module__visible___UjNsX {
  opacity: 1;
}

.SeparatorLine-module__invisible___kVEI4 {
  opacity: 0;
}

.SeparatorLine-module__col-90___a9OXv {
  width: 90% !important;
}

.SeparatorLine-module__col-auto___vZ1rb {
  width: auto !important;
}

.SeparatorLine-module__medical-tabs___XmGB_ {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SeparatorLine-module__medical-table-new___Wia6F {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SeparatorLine-module__medical-table-new___Wia6F:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SeparatorLine-module__medical-table-new___Wia6F::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SeparatorLine-module__medical-table-new___Wia6F::-webkit-scrollbar-track {
  display: none;
}
.SeparatorLine-module__medical-table-new___Wia6F.SeparatorLine-module__no-pagination___Fhzuy {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SeparatorLine-module__medical-table-new___Wia6F.SeparatorLine-module__no-pagination___Fhzuy:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SeparatorLine-module__medical-table-new___Wia6F.SeparatorLine-module__no-pagination___Fhzuy::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SeparatorLine-module__medical-table-new___Wia6F.SeparatorLine-module__no-pagination___Fhzuy::-webkit-scrollbar-track {
  display: none;
}

.SeparatorLine-module__medical-table-empty___mdC4N {
  padding: 14px 40px !important;
}

.SeparatorLine-module__icon-btn___UFP6B {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SeparatorLine-module__search-icon___v5SMa {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SeparatorLine-module__disable-select___uHiT7 {
  user-select: none;
}

.SeparatorLine-module__break-word___xo55x {
  word-break: break-word;
}

.SeparatorLine-module__popup-clear-btn___YHCDa {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SeparatorLine-module__scroll-m-b-20___HBe1v {
  scroll-margin-bottom: 20px;
}

.SeparatorLine-module__verticalLine___T6sWW,
.SeparatorLine-module__horizontalLine___WTQvd {
  display: flex;
  background-color: #e6e7e8;
}

.SeparatorLine-module__verticalLine___T6sWW {
  width: 1px;
  height: 100%;
}

.SeparatorLine-module__horizontalLine___WTQvd {
  height: 1px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/elements/SeparatorLine/SeparatorLine.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;;EAEE,aAAA;EACA,yBAAA;AA8pBF;;AA3pBA;EACE,UAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,WAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.verticalLine,\n.horizontalLine {\n  display: flex;\n  background-color: get-color(gray, light);\n}\n\n.verticalLine {\n  width: 1px;\n  height: 100%;\n}\n\n.horizontalLine {\n  height: 1px;\n  width: 100%;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SeparatorLine-module__font-s-10___zvtAV`,
	"fontS12": `SeparatorLine-module__font-s-12___W83Kb`,
	"fontS13": `SeparatorLine-module__font-s-13___on1S7`,
	"fontS14": `SeparatorLine-module__font-s-14___KxQpm`,
	"fontS15": `SeparatorLine-module__font-s-15___MeZ74`,
	"fontS16": `SeparatorLine-module__font-s-16___wEc5m`,
	"fontS18": `SeparatorLine-module__font-s-18___mUsFd`,
	"fontS20": `SeparatorLine-module__font-s-20___gTXSI`,
	"fontS22": `SeparatorLine-module__font-s-22___B7g6m`,
	"fontS28": `SeparatorLine-module__font-s-28___k3cns`,
	"fontW400": `SeparatorLine-module__font-w-400___EmaIc`,
	"fontW500": `SeparatorLine-module__font-w-500___CXHf9`,
	"fontW600": `SeparatorLine-module__font-w-600___NpxCT`,
	"fontW700": `SeparatorLine-module__font-w-700___kHOT3`,
	"p5": `SeparatorLine-module__p-5___OGZir`,
	"p12": `SeparatorLine-module__p-12___UDmba`,
	"p16": `SeparatorLine-module__p-16___sonIr`,
	"p30": `SeparatorLine-module__p-30___JcIwr`,
	"pB0": `SeparatorLine-module__p-b-0___BpzSk`,
	"pB5": `SeparatorLine-module__p-b-5___xP9YU`,
	"pB10": `SeparatorLine-module__p-b-10___C05WU`,
	"pB12": `SeparatorLine-module__p-b-12___MEV7e`,
	"pB16": `SeparatorLine-module__p-b-16___Qh_CK`,
	"pB18": `SeparatorLine-module__p-b-18___oPOMz`,
	"pB20": `SeparatorLine-module__p-b-20___D9S8k`,
	"pB25": `SeparatorLine-module__p-b-25___NK22f`,
	"pB30": `SeparatorLine-module__p-b-30___aPxag`,
	"pB50": `SeparatorLine-module__p-b-50___aOoRo`,
	"pT0": `SeparatorLine-module__p-t-0___tFBVS`,
	"pT12": `SeparatorLine-module__p-t-12___pcOO7`,
	"pT16": `SeparatorLine-module__p-t-16___inVw1`,
	"pT18": `SeparatorLine-module__p-t-18___pApgL`,
	"pT20": `SeparatorLine-module__p-t-20___d1hV0`,
	"pT30": `SeparatorLine-module__p-t-30___xqr2F`,
	"pT40": `SeparatorLine-module__p-t-40___hpq7u`,
	"pT50": `SeparatorLine-module__p-t-50___weqDy`,
	"pL20": `SeparatorLine-module__p-l-20___HXE7g`,
	"pL30": `SeparatorLine-module__p-l-30___I09fJ`,
	"pL40": `SeparatorLine-module__p-l-40___zlwAd`,
	"pR16": `SeparatorLine-module__p-r-16___scSxZ`,
	"pR20": `SeparatorLine-module__p-r-20___lq_zE`,
	"pR30": `SeparatorLine-module__p-r-30___mDQOs`,
	"pR50": `SeparatorLine-module__p-r-50___CVxin`,
	"pR60": `SeparatorLine-module__p-r-60___nyJ68`,
	"mB1": `SeparatorLine-module__m-b-1___ZTu2U`,
	"mB2": `SeparatorLine-module__m-b-2___jYoDn`,
	"mB6": `SeparatorLine-module__m-b-6___hEnMa`,
	"mB8": `SeparatorLine-module__m-b-8___qi58O`,
	"mB10": `SeparatorLine-module__m-b-10___ggCSM`,
	"mB14": `SeparatorLine-module__m-b-14___RGv1S`,
	"mB16": `SeparatorLine-module__m-b-16___Xbj59`,
	"mB20": `SeparatorLine-module__m-b-20___IkXlY`,
	"mB22": `SeparatorLine-module__m-b-22___NuUza`,
	"mB24": `SeparatorLine-module__m-b-24___jVNnD`,
	"mB30": `SeparatorLine-module__m-b-30___nay8i`,
	"mB32": `SeparatorLine-module__m-b-32___ii4c8`,
	"mB40": `SeparatorLine-module__m-b-40___YEpIE`,
	"mT2": `SeparatorLine-module__m-t-2___k6V9n`,
	"mT3": `SeparatorLine-module__m-t-3___Xz0pi`,
	"mT4": `SeparatorLine-module__m-t-4___IrIUq`,
	"mT5": `SeparatorLine-module__m-t-5___HtCqC`,
	"mT8": `SeparatorLine-module__m-t-8___g8Q_7`,
	"mT10": `SeparatorLine-module__m-t-10___qxE0x`,
	"mT15": `SeparatorLine-module__m-t-15____MtkX`,
	"mT16": `SeparatorLine-module__m-t-16___N26KF`,
	"mT20": `SeparatorLine-module__m-t-20___qEthe`,
	"mT22": `SeparatorLine-module__m-t-22___FFxtz`,
	"mT30": `SeparatorLine-module__m-t-30___Yftwf`,
	"mT32": `SeparatorLine-module__m-t-32___ZZ2Tj`,
	"mLAuto": `SeparatorLine-module__m-l-auto___JJPNX`,
	"mL4": `SeparatorLine-module__m-l-4___FNN6U`,
	"mL5": `SeparatorLine-module__m-l-5___X311K`,
	"mL6": `SeparatorLine-module__m-l-6___TuWr4`,
	"mL8": `SeparatorLine-module__m-l-8___XG0F8`,
	"mL10": `SeparatorLine-module__m-l-10___BPm70`,
	"mL16": `SeparatorLine-module__m-l-16___Ayk9j`,
	"mL20": `SeparatorLine-module__m-l-20___fJLaX`,
	"mL24": `SeparatorLine-module__m-l-24___uPrRl`,
	"mL30": `SeparatorLine-module__m-l-30___PyEjN`,
	"mL35": `SeparatorLine-module__m-l-35___t6Fkz`,
	"mL40": `SeparatorLine-module__m-l-40___bBd7Z`,
	"mR8": `SeparatorLine-module__m-r-8___QJC9j`,
	"mR10": `SeparatorLine-module__m-r-10___zBG5t`,
	"mR16": `SeparatorLine-module__m-r-16___QQyF6`,
	"mR20": `SeparatorLine-module__m-r-20___gisEb`,
	"mR24": `SeparatorLine-module__m-r-24___QStck`,
	"mR30": `SeparatorLine-module__m-r-30___nYkIN`,
	"mR40": `SeparatorLine-module__m-r-40___rGWGT`,
	"borderR3": `SeparatorLine-module__border-r-3___nC60m`,
	"borderR4": `SeparatorLine-module__border-r-4___LfCK8`,
	"borderR6": `SeparatorLine-module__border-r-6___rPHcI`,
	"borderR10": `SeparatorLine-module__border-r-10___MWWxJ`,
	"borderR12": `SeparatorLine-module__border-r-12___NynAS`,
	"borderR16": `SeparatorLine-module__border-r-16___z4pR2`,
	"borderR50": `SeparatorLine-module__border-r-50___DntHm`,
	"primaryBorder": `SeparatorLine-module__primary-border___KonWx`,
	"primaryBorderB": `SeparatorLine-module__primary-border-b___jEzEj`,
	"primaryBorderT": `SeparatorLine-module__primary-border-t___Y1BFx`,
	"primaryBorderL": `SeparatorLine-module__primary-border-l___Jl_Hy`,
	"primaryBorderR": `SeparatorLine-module__primary-border-r___kk2_j`,
	"secondaryBorder": `SeparatorLine-module__secondary-border___jw8rl`,
	"secondaryBorderB": `SeparatorLine-module__secondary-border-b___R7WGS`,
	"secondaryBorderT": `SeparatorLine-module__secondary-border-t___yLN9P`,
	"secondaryBorderL": `SeparatorLine-module__secondary-border-l___XcLOy`,
	"secondaryBorderR": `SeparatorLine-module__secondary-border-r___TEyiT`,
	"gap0": `SeparatorLine-module__gap-0___Myj8k`,
	"gap2": `SeparatorLine-module__gap-2___Xc4Bh`,
	"gap4": `SeparatorLine-module__gap-4___TLGDE`,
	"gap5": `SeparatorLine-module__gap-5___yTnD7`,
	"gap6": `SeparatorLine-module__gap-6___ZObg_`,
	"gap8": `SeparatorLine-module__gap-8___ZuOlR`,
	"gap10": `SeparatorLine-module__gap-10___HeDGj`,
	"gap12": `SeparatorLine-module__gap-12___Ia44U`,
	"gap14": `SeparatorLine-module__gap-14___lwttQ`,
	"gap16": `SeparatorLine-module__gap-16____BqrX`,
	"gap18": `SeparatorLine-module__gap-18___C2RnX`,
	"gap20": `SeparatorLine-module__gap-20___iifhu`,
	"gap24": `SeparatorLine-module__gap-24___vg2xG`,
	"gap26": `SeparatorLine-module__gap-26___qQGlt`,
	"gap30": `SeparatorLine-module__gap-30___Ui2Hc`,
	"gap32": `SeparatorLine-module__gap-32___unGeY`,
	"gap40": `SeparatorLine-module__gap-40___wDTg3`,
	"gap50": `SeparatorLine-module__gap-50___bibKz`,
	"flex1": `SeparatorLine-module__flex-1___aQLKw`,
	"flexNone": `SeparatorLine-module__flex-none___b7By0`,
	"flexColumn": `SeparatorLine-module__flex-column___wRcYO`,
	"flexRow": `SeparatorLine-module__flex-row___BW0ef`,
	"verticallyCentered": `SeparatorLine-module__vertically-centered___byXDG`,
	"horizontallyCentered": `SeparatorLine-module__horizontally-centered___bpZ5p`,
	"horizontallyEnd": `SeparatorLine-module__horizontally-end___MczDj`,
	"verticallyStart": `SeparatorLine-module__vertically-start___eKCHu`,
	"spaceBetween": `SeparatorLine-module__space-between___zdMuN`,
	"flexWrap": `SeparatorLine-module__flex-wrap____nteG`,
	"height100": `SeparatorLine-module__height-100___lUcK1`,
	"width50": `SeparatorLine-module__width-50___W70BG`,
	"width100": `SeparatorLine-module__width-100___Oc0jD`,
	"cursorPointer": `SeparatorLine-module__cursor-pointer___n40FR`,
	"cursorNotAllowed": `SeparatorLine-module__cursor-not-allowed___HIU_m`,
	"absoluteCentered": `SeparatorLine-module__absolute-centered___poS94`,
	"absolute": `SeparatorLine-module__absolute___Cfknh`,
	"relative": `SeparatorLine-module__relative___YoqEh`,
	"fixed": `SeparatorLine-module__fixed___piBmG`,
	"visible": `SeparatorLine-module__visible___UjNsX`,
	"invisible": `SeparatorLine-module__invisible___kVEI4`,
	"col90": `SeparatorLine-module__col-90___a9OXv`,
	"colAuto": `SeparatorLine-module__col-auto___vZ1rb`,
	"medicalTabs": `SeparatorLine-module__medical-tabs___XmGB_`,
	"medicalTableNew": `SeparatorLine-module__medical-table-new___Wia6F`,
	"noPagination": `SeparatorLine-module__no-pagination___Fhzuy`,
	"medicalTableEmpty": `SeparatorLine-module__medical-table-empty___mdC4N`,
	"iconBtn": `SeparatorLine-module__icon-btn___UFP6B`,
	"searchIcon": `SeparatorLine-module__search-icon___v5SMa`,
	"disableSelect": `SeparatorLine-module__disable-select___uHiT7`,
	"breakWord": `SeparatorLine-module__break-word___xo55x`,
	"popupClearBtn": `SeparatorLine-module__popup-clear-btn___YHCDa`,
	"scrollMB20": `SeparatorLine-module__scroll-m-b-20___HBe1v`,
	"verticalLine": `SeparatorLine-module__verticalLine___T6sWW`,
	"horizontalLine": `SeparatorLine-module__horizontalLine___WTQvd`
};
module.exports = ___CSS_LOADER_EXPORT___;
